import axiosInstance from 'api/axiosInstance';

export interface Customer {
  Id: number;
  Name: string;
  [key: string]: any;
}

export interface SearchCustomersParams {
  SearchKeyword?: string;
  Page?: number;
  Take?: number;
  Id?: number;
}

export const searchCustomers = async (
  params: SearchCustomersParams = {}
): Promise<Customer[]> => {
  try {
    const payload = {
      Id: params.Id || 0,
      SearchKeyword: params.SearchKeyword || '',
      Page: params.Page || 1,
      Take: params.Take || 100,
    };

    const response = await axiosInstance.get(
      '/api/candispatchv3/SearchDispatchCustomers',
      {
        params: payload,
        paramsSerializer: (params) => `payload=${JSON.stringify(params)}`,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        data: null, // Required for axios to send Content-Type header on GET
      }
    );

    const data = response.data?.Data || response.data || [];
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Error searching customers:', error);
    throw error;
  }
};

export default searchCustomers;
